"use client";
import Link from "next/link";
import UniversityRightArrowSvg from "../../uni-right-arrow-svg";
import { sanitizeInput } from "@packages/lib/utlils/sanitization";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import Accordion from "@packages/shared-components/common-utilities/accordion/accordion";
const UniversityGroupFilterAccordian = ({
  jsondata,
  keyName,
  formUrl,
  appendSearchParams,
}: any) => {
  const { prepopulateFilter, setPrepopulateFilter, filterState, slug } =
    useFilterContext();
  return (
    <>
      {slug?.split("/")[2] !== "csearch" &&
        !filterState?.filterOrder?.university &&
        !prepopulateFilter?.University && (
          <>
            {jsondata?.universityGroupList?.length > 0 && (
              <Accordion
                title="University group"
                defaultOpenStatus={
                  filterState?.selectedFilter === "all" || false
                }
              >
                <div className="flex flex-col gap-[8px] pt-[24px]">
                  <div className="x-small font-semibold text-black uppercase">
                    Choose one
                  </div>
                  <div className="flex flex-col gap-[12px]">
                    {jsondata?.universityGroupList?.map(
                      (uniGroupListItem: any, index: number) => (
                        <div className="form_check relative" key={index}>
                          <div className="flex items-start gap-[8px]">
                            <div className="checkbox_card">
                              {/* <Link
                                className="hidden"
                                id={
                                  sanitizeInput(keyName?.russellGroup) +
                                  sanitizeInput(
                                    uniGroupListItem?.universityGroupTextKey
                                  )
                                }
                                href={{
                                  pathname: generatePathName(
                                    slug,
                                    keyName?.russellGroup
                                  ),
                                  query: formUrl(
                                    keyName?.russellGroup,
                                    sanitizeInput(
                                      uniGroupListItem?.universityGroupTextKey
                                    )
                                  ),
                                }}
                              >
                                {uniGroupListItem?.universityGroupDesc}
                              </Link> */}
                              <input
                                type="checkbox"
                                className="form-checkbox hidden"
                                id={uniGroupListItem?.universityGroupDesc}
                                checked={
                                  prepopulateFilter?.russellGroup ===
                                  uniGroupListItem?.universityGroupTextKey?.toLowerCase()
                                }
                                onChange={() => {
                                  appendSearchParams(
                                    keyName?.russellGroup,
                                    sanitizeInput(
                                      uniGroupListItem?.universityGroupTextKey?.toLowerCase(),
                                    ),
                                  );
                                  setPrepopulateFilter((prev: any) => ({
                                    ...prev,
                                    russellGroup:
                                      prev?.russellGroup ==
                                      uniGroupListItem?.universityGroupTextKey
                                        ? ""
                                        : uniGroupListItem?.universityGroupTextKey,
                                  }));
                                }}
                              />
                              <label
                                htmlFor={uniGroupListItem?.universityGroupDesc}
                                className="flex justify-center items-center w-[16px] h-[16px] rounded-[3px] border-2 border-grey-600 my-[2px] group-checked:bg-primary-400 cursor-pointer"
                              >
                                <UniversityRightArrowSvg />
                              </label>
                            </div>
                            <label
                              htmlFor={uniGroupListItem?.universityGroupDesc}
                              className="check-label small font-normal text-grey300 w-[calc(100%_-_28px)]"
                            >
                              {uniGroupListItem?.universityGroupDesc}
                            </label>
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              </Accordion>
            )}
          </>
        )}
    </>
  );
};

export default UniversityGroupFilterAccordian;
